<template>
    <div>
      <div class="clearfix">
        <div class="title-content content1 clearfix" style="display:block;float:left;width:67%;">
          <div class="title-content-a clearfix" style="height:150px;margin:0;width:100%;">
            <div class="title-content-a-view" style="width:100%;height:150px;background:#FFF;">
                <p class="ycsj_p" style="border-bottom:1px solid #CBC1C1;padding-top:30px;font-size:16px;padding-left:0;padding-bottom:10px;margin-left:20px;margin-right:20px;">
                  <span>消息统计</span>
                  <span style="float:right;">最新更新时间：{{requestTime}}</span>
                </p>

              <div class="title-message">
                <ul class="clearfix">
                  <li>
                    <img src="../../assets/images/jiaoyi.png" alt="">
                    <p>
                      <span>累计交易量</span>
                      <br>
                      <span>{{messageThings}}</span>
                    </p>
                  </li>
                  <li>
                    <img src="../../assets/images/message.png" alt="">
                    <p>
                      <span>消息总数</span>
                      <br>
                      <span>{{messageThings2}}</span>
                    </p>
                  </li>
                  <li>
                    <img src="../../assets/images/time.png" alt="">
                    <p>
                        <span>平均响应时间</span>&nbsp;
                        <span @click="aveTimeShow">
                          <i class="el-icon-question"></i>
                        </span>
                        <!-- <div class="aveTimeHide" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;">
                            取当前时间之前半个小时10秒范围数据除以10
                        </div> -->
                      <!-- <span>平均响应时间</span> -->
                      <br>
                      <span>{{messageThings3}}</span>
                    </p>
                    <div class="aveTimeHide" style="background-color:#ededed;width:310px;height:auto;display:none;padding: 10px;">
                        取当前时间之前半个小时10秒范围数据除以10
                    </div>
                  </li>
                  <li>
                    <img src="../../assets/images/kuandai.png" alt="">
                    <p>
                        <span>平均带宽</span>&nbsp;
                        <span @click="aveBroadbandShow">
                          <i class="el-icon-question"></i>
                        </span>
                      <!-- <span>平均宽带</span> -->
                      <br>
                      <span>{{messageThings4}}</span>
                    </p>
                    <div class="aveBroadbandHide" style="background-color:#ededed;width:280px;height:auto;display:none;padding: 10px;">
                        之前累积统计查询数量除以累积查询时间
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="title-content-a2 title-content-a" style="margin-bottom:0;background:#FFF;">
              <p class="ycsj_p" style="margin-left:20px;font-size:16px;padding-left:0;">全网运行状况</p>
              <div id="mainMap">

              </div>
              
          </div>
        </div>

           

        <div class="title-content content2" style="width:32%;float:right;height:821px;background:#fff;position:relative;">
          <div class="title-content-a1" style="width:9%;position:absolute;left:-18px;top:50%;">
            <el-button class="butt1" icon="el-icon-d-arrow-left" style="width:50%;" @click="left()"></el-button>
          </div>
          <div class="title-content-a1" style="width:9%;position:absolute;left:-18px;top:50%;">
            <el-button class="butt2" icon="el-icon-d-arrow-right" style="width:50%;display:none;" @click="right()"></el-button>
          </div>
          <div class="title-content-a clearfix" style="width:100%;margin:0;height:821px;">
            <p class="ycsj_p" style="border-bottom:1px solid #CBC1C1;padding-top:30px;font-size:16px;padding-left:0;padding-bottom:10px;margin-left:20px;margin-right:20px;">Node列表</p>
            <!-- <div class="clearfix">
              <ul class="ycsj_p_ul clearfix">
                <li>
                  <span class="ycsj_p_ul_span">录制时长</span>
                  <br>
                  <span class="ycsj_p_ul_span2">{{timeT}}</span>
                </li>
                <li>
                  <span class="ycsj_p_ul_span">累计个数</span>
                  <br>
                  <span class="ycsj_p_ul_span2">00</span>
                </li>
              </ul>
              <el-button type="danger" @click="start" size="small" style="margin-top:30px;">录制</el-button>
            </div> -->
            <br>
            <el-table
              :data="echartsDraw"
              :row-style="getRowClass"
              :header-cell-style="getRowClass"
              style="width: 91%;margin:0 20px;background:#F3F3F4;"
              border
              >
              <el-table-column
                width="50"
                align="center"
                label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.node.nodeStatus == 'NORMAL'" style="font-size:23px;color:#22B14C;">●</span>
                  <span v-if="scope.row.node.nodeStatus == 'CANCEL'" style="font-size:23px;color:red;">●</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="node.nodeInZone"
                width="80"
                label="分区">
              </el-table-column>

              <el-table-column
                prop="nodeID"
                label="NodeID">
                <template slot-scope="scope">
                  <router-link :to="{path:'/dseed',query:{nodeid:scope.row.node.nodeID,'nodes':scope.row.node.nodeID,'zoneid':scope.row.node.nodeInZone,'node_type':scope.row.nodeType,'thread':'first'}}" style="text-decoration:none;">
                    <span style="color:#1385F9;">{{scope.row.node.nodeID}}</span>
                  </router-link>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="node.instanceName"
                width="150"
                label="instanceName"
                :filters=this.num
                :filter-method="filterTag">
              </el-table-column> -->
              <el-table-column
                prop="node.instanceName"
                width="150"
                label="instanceName">
              </el-table-column>
              <el-table-column
                prop="startTime"
                width="160"
                label="最后修改时间">
                <!-- <template slot-scope="scope">
                  <span>{{scope.slice(19)}}</span>
                </template> -->
              </el-table-column>
              <el-table-column
                prop="registTime"
                width="160"
                label="本次注册时间">
                <!-- <template slot-scope="scope">
                  <span>{{scope.slice(19)}}</span>
                </template> -->
              </el-table-column>
              
              <el-table-column
                prop="city"
                label="地区">
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="page.pageNum"
              style="text-align:center;margin-top:8px;"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="page.totalSize">
            </el-pagination>
          </div>
        </div>
      </div>
      <el-dialog :modal-append-to-body='false' title="信息" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
          <el-table-column property="date" label="MessageID" width="150"></el-table-column>
          <el-table-column property="name" label="Type" width="200"></el-table-column>
          <el-table-column property="address" label="From"></el-table-column>
          <el-table-column property="address" label="To"></el-table-column>
          <el-table-column property="address" label="Body"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialog">下 载</el-button>
        </div>
      </el-dialog>
      <!-- <div v-for="(item,index) in this.arr" :key="index">{{item}}</div> -->
    </div>
</template>
<script>
import $ from 'jquery';
import echarts from "echarts";
var hour,minute,second;//时 分 秒
hour=minute=second=0;//初始化
var millisecond=0;//毫秒
var int;
import {china} from "../../assets/json/china.js";
import {pathFile} from "../../assets/js/common.js";
  //在月份、日期、小时等小于10前面补0
  var padDate = function (value) {
    return value <10 ? '0' + value:value;
  };
export default {
  name: "cube",
  data(){
    return{
      requestTime:'',
      date: new Date(),
      timeT:'0:0:0',
      gridData: [],
      dialogTableVisible: false,
      messageThings:'', //消息总数
      messageThings2:'', //消息总数
      messageThings3:'', //消息总数
      messageThings4:'', //消息总数
      form:{
          start_date:'',
          end_date:'',
          daterangevalue:'',
      },
      tableData: [],
      filters: {
        userName: "",
        //岗位列表搜索参数
        positionName: "",
        positionCode: "",
      },
      echartsDraw:[],
      page:{
          pageSize:12,
          totalSize:10,
          pageNum:1
      },
      path:pathFile+"webSocket/1",
      socket:"",
      filter:[],
      num:[],
      instanceName: [],
      arr: []
    }
  },
  filters: {
    formatDate:function (value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = padDate(date.getMonth()+1);
      var day = padDate(date.getDate());
      var hours = padDate(date.getHours());
      var minutes = padDate(date.getMinutes());
      var seconds = padDate(date.getSeconds());
      return year + '-' + month + '-' + day + '-' + ' ' + hours + ':' + minutes + ':' + seconds;
    }
  },
  //实例创建完成后调用，此阶段完成了数据的观测等，但尚未挂载，$el 还不可用。需要初始化处理一些数据时会比较有用
    created:function () {

    },
    //el挂载到实例上后调用，一般我们的第一个业务逻辑会在这里开始
    mounted:function () {
      var _this = this; //声明一个变量指向Vue实例this，保证作用域一致
      this.init();
      this.timer = setInterval(function(){
        _this.date = new Date(); //修改数据date
        // _this.requestTime = new Date(); 
        // window.onload();
      },10000);
      // this.setIn1 = setInterval(()=>{
      //   this.messageTj();
      //   this.getNodeLists();
      // },1000*60);
      this.drawLine();
      this.messageTj();
      this.getNodeLists();
    },
    //实例销毁之前调用。主要解绑一些使用addEventListener监听的事件等
    beforeDestroy:function(){
      if(this.timer){
        clearInterval(this.timer); //在Vue实例销毁前，清除我们的定时器
      }
      // if(this.setIn1){
      //   clearInterval(this.setIn1); //在Vue实例销毁前，清除我们的定时器
      // }
    },
    destroyed:function() {
      this.socket.close();
    },
    methods:{
      //左右滑动
      left(){
        $('.content1').css('width','41%');
        $('.content2').css('width','58%');
        $('.butt1').hide();
        $('.butt2').show();

      },
      right(){
        $('.content1').css('width','58%');
        $('.content2').css('width','41%');
        $('.butt1').show();
        $('.butt2').hide();
      },
      filterTag(value, row) {
        console.log(value)
        return row.node.instanceName === value;
      },

      getRowClass() {
          return "background:#F3F3F4;";
      },
      init: function () {
          if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
          }else{
            // 实例化socket
            this.socket = new WebSocket(this.path)
            // 监听socket连接
            this.socket.onopen = this.open
            // 监听socket错误信息
            this.socket.onerror = this.error
            // 监听socket消息
            this.socket.onmessage = this.getMessage
            this.socket.onclose = this.websocketclose
          }
        },
        open: function () {
          console.log("socket连接成功")
        },
        websocketclose(e){  //关闭
          console.log('断开连接',e);
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (msg) {
          var echartsDraw2 = JSON.parse(msg.data);
          console.log(echartsDraw2)
          this.requestTime = echartsDraw2.requestTime;
          if(echartsDraw2.transactionCount != undefined){
            this.messageThings = echartsDraw2.transactionCount
          }
          if(echartsDraw2.messageCount != undefined){
            this.messageThings2 = echartsDraw2.messageCount
          }
          if(echartsDraw2.responseTime != undefined){
            this.messageThings3 = echartsDraw2.responseTime+"ms"
          }
          if(echartsDraw2.broadband != undefined){
            this.messageThings4 = echartsDraw2.broadband+"个/秒"
          }

          if(echartsDraw2.nodeInfoList != undefined){
            var echartsDrawA2 = []; //nodeid
            for(let i=0;i<echartsDraw2.nodeInfoList.length;i++){
              echartsDrawA2.push({name: 'NodeId', datas:[echartsDraw2.nodeInfoList[i].node.nodeID],value: [echartsDraw2.nodeInfoList[i].lng, echartsDraw2.nodeInfoList[i].lat]});
            }
            // 基于准备好的dom，初始化echarts实例
            var mainMap = echarts.init(document.getElementById('mainMap'));
            mainMap.setOption({
              series:[{
                data:echartsDrawA2
              }]
            })
          }


        },
        send: function () {
          this.socket.send(params)
        },
        close: function () {
          console.log("socket已经关闭")
        },
      handleCurrentChange(val) {
        this.arr = []
        this.num = []
        this.page.pageNum = val;
        this.getNodeLists();
      },
      handleSizeChange(val) {
        this.arr.length = 0
        this.num = []
        this.page.pageSize = val;
        this.getNodeLists();
     },
      //消息统计
      messageTj(){
        let params = {
            type:1
        };
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getCountData',
            data:params
        }).then((res)=>{
            this.requestTime = res.data.requestTime;
            this.messageThings = res.data.countData;
            // console.log(this.requestTime);
        });
        let params2 = {
            type:2
        };
        params2 = this.$qs.stringify(params2,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getCountData',
            data:params2
        }).then((res)=>{
            this.messageThings2 = res.data.countData;
        })
        let params3 = {
            type:3
        };
        params3 = this.$qs.stringify(params3,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getCountData',
            data:params3
        }).then((res)=>{
            this.messageThings3 = res.data.countData+"ms";
        })
        let params4 = {
            type:4
        };
        params4 = this.$qs.stringify(params4,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getCountData',
            data:params4
        }).then((res)=>{
            this.messageThings4 = res.data.countData+'个/秒';
             this.requestTime = res.data.requestTime;
            // console.log(this.requestTime);
        })
      },
      //统计时间
      start(){
        var _this = this;
        int=setInterval(function() {
          millisecond=millisecond+50;
          if(millisecond>=1000)
          {
            millisecond=0;
            second=second+1;
          }
          if(second>=60)
          {
            second=0;
            minute=minute+1;
          }

          if(minute>=60)
          {
            minute=0;
            hour=hour+1;
          }
          _this.timeT=hour+':'+minute+':'+second;
        },50);
      },
      dialog(){
        this.dialogTableVisible = false;
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      //查询Node列表
      getNodeLists(){
        let params = {
            isPageFlag:'1',//分页
            pageNum:this.page.pageNum,
            pageSize:this.page.pageSize,
        }
        // console.log(params);
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getNodeList',
            data:params,
        }).then((res)=>{
          res.data.list.map((item,index)=>{
            item.startTime = item.modifyTime.slice(0,19);
            item.registTime = item.registTime.slice(0,19); 
            // let str=item
            // if(str.node.nodeStatus === 'NORMAL'){
            //   if(str.node.instanceName.slice(0,4) === 'node'){
            //     this.arr.unshift(str)
            //   }else{
            //     this.arr.push(str)
            //   }
            // }else if(str.node.nodeStatus === "CANCEL" && str.node.instanceName.slice(0,4) !== 'node'){
            //     this.arr.push(str)
            // }else if(str.node.nodeStatus === 'NORMAL' || str.node.nodeStatus === "CANCEL" && str.node.instanceName.slice(0,4) === 'node'){
            //     this.arr.unshift(str)
            // }
          })
          // console.log(this.arr)
          this.echartsDraw = res.data.list;
          // if(this.arr.length === 12){
          //   this.echartsDraw  = this.arr
          // }
          this.page = res.data.page;

          this.arr = []
          // console.log(this.page)
          var num = [];
          for(var i = 0;i<this.echartsDraw.length;i++){
            this.filter[i] = this.echartsDraw[i].node.instanceName;
            // this.num= new Array({"text":this.filter[i],"value":this.filter[i]});
            this.num.push({"text":this.filter[i],"value":this.filter[i]});
          }
          // console.log(this.num);
        })
      },
     
      //地图
      drawLine(){
        var mainMap = echarts.init(document.getElementById('mainMap'));
        mainMap.showLoading();
        let params = {
            isPageFlag:'0',//不分页
            pageNum:'1',
            pageSize:'100'
        }
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getNodeList',
            data:params,
            timeout:10000
        }).then((res)=>{
            // console.log(res.data);
            var echartsDraw = res.data.list;
            var echartsDrawA = []; //nodeid
            for(let i=0;i<echartsDraw.length;i++){

              if(echartsDraw[i].status == 'CANCEL'){
                echartsDrawA.push({name: 'NodeId', datas:[echartsDraw[i].node.nodeID],value: [echartsDraw[i].lng, echartsDraw[i].lat,'2']});
              }else{
                echartsDrawA.push({name: 'NodeId', datas:[echartsDraw[i].node.nodeID],value: [echartsDraw[i].lng, echartsDraw[i].lat,'1']});

              }
              // console.log(echartsDrawA);
            }
            // console.log(echartsDrawA);
            // 基于准备好的dom，初始化echarts实例
            mainMap.hideLoading();
              var geoJson = china;
              var features = geoJson.features;
            //var colorArr = setAreaColor(features);
              echarts.registerMap('china', geoJson);
              var mytextStyle = {
                  color: "black", //文字颜色
                  fontStyle: "normal", //italic斜体  oblique倾斜
                  fontWeight: "bold", //文字粗细bold   bolder   lighter  100 | 200 | 300 | 400...
                  fontFamily: "sans-serif", //字体系列
                  fontSize: 18, //字体大小
              };

              var myitemStyle = {
                  color: "#0090ff", //颜色
                  borderColor: "#000", //边框颜色
                  borderWidth: 0, //柱条的描边宽度，默认不描边。
                  borderType: "solid", //柱条的描边类型，默认为实线，支持 'dashed', 'dotted'。
                  barBorderRadius: 0, //柱形边框圆角半径，单位px，支持传入数组分别指定柱形4个圆角半径。
                  shadowBlur: 20, //图形阴影的模糊大小。
                  shadowColor: "#000", //阴影颜色
                  shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                  shadowOffsetY: 0, //阴影垂直方向上的偏移距离。
                  opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
              };

              // var scatterEmphasisStyle = {
              //     color: "#ff634d", //颜色
              //     borderColor: "#ff634d", //边框颜色
              //     borderWidth: 0, //柱条的描边宽度，默认不描边。
              //     borderType: "solid", //柱条的描边类型，默认为实线，支持 'dashed', 'dotted'。
              //     barBorderRadius: 0, //柱形边框圆角半径，单位px，支持传入数组分别指定柱形4个圆角半径。
              //     shadowBlur: 0, //图形阴影的模糊大小。
              //     shadowColor: "#000", //阴影颜色
              //     shadowOffsetX: 0, //阴影水平方向上的偏移距离。
              //     shadowOffsetY: 0, //阴影垂直方向上的偏移距离。
              //     opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
              // };
              mainMap.setOption({  //这里面是配置地图
                  legend:{
                    itemGap:20,
                    x:'right'
                  },
                  geo: {
                      roam: false, //是否开启鼠标缩放和平移漫游
                      scaleLimit: { //所属组件的z分层，z值小的图形会被z值大的图形覆盖
                          min: 1, //最小的缩放值
                          max: 5, //最大的缩放值
                      },
                      roam: true,
                      //regions: colorArr,
                      zoom: 1.2,
                      scaleLimit:{min:1.2,max:100},
                      label: { //图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
                          normal: {
                              show: false, //是否在普通状态下显示标签。
                              areaColor:'red',
                              // textStyle: mytextStyle, //普通状态下的标签文本样式。
                              color:'red'
                          },
                          emphasis: {
                              show: true, //是否在高亮状态下显示标签。
                              areaColor:'red',
                              textStyle: mytextStyle, //高亮状态下的标签文本样式。
                              areaStyle: {
                                  color: mytextStyle
                              }
                          }
                      },
                      layoutSize: 80, //地图的大小,支持相对于屏幕宽高的百分比或者绝对的像素大小。
                      map: 'china'
                  },
                  //提示框组件
          		    tooltip: {
                      showContent: true,
                      alwaysShowContent: false,
                      trigger: 'item',
        	            "formatter": (p)=>{//自定义提示信息
        	              	let dataCon = p.data;
        	                var result = '<div>nodeId：'+dataCon.datas[0]+'</div>';
        	                return result;
        	            }
          		    },
                  visualMap: {
                		type: 'continuous', // 连续型
                		min: 1,       		// 值域最小值，必须参数
                		max: 2,			// 值域最大值，必须参数
                		// calculable: true,	// 是否启用值域漫游
                		show:false,
                		inRange: {
                      color: ['rgb(34, 177, 76)','red']
                    },
                  },
                  series: [
                      {
                         itemStyle: {
                              normal: {
                                  color: "red" //颜色
                              },
                              emphasis: {
                                  borderColor: "#fff",
                                  borderWidth: 1
                              }
                          },
                          name: 'BLOCK信息',
                          type: 'scatter',
                          //hoverable: true,
                          //silent:true,
                          coordinateSystem: 'geo',
                          roam: true,
                          symbol: "circle", //图形 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
                          symbolSize: 9, //标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示宽和高，例如 [20, 10] 表示标记宽为20，高为10。
                          symbolRotate: 0, //标记的旋转角度。注意在 markLine 中当 symbol 为 'arrow' 时会忽略 symbolRotate 强制设置为切线的角度。
                          large: false,
                          itemStyle: { //图形样式，normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式，比如在鼠标悬浮或者图例联动高亮时。
                              normal: myitemStyle,
                              // emphasis: scatterEmphasisStyle,
                          },
                          encode: { //可以定义 data 的哪个维度被编码成什么
                            // x: [3, 1, 5],           // 表示维度 3、1、5 映射到 x 轴。
                            // y: 2,                   // 表示维度 2 映射到 y 轴。
                            // tooltip: [
                            //     0, 1, 2, 3
                            // ], // 表示维度 3、2、4 会在 tooltip 中显示。
                            // label: 3                // 表示 label 使用维度 3。
                          },
                          //hoverAnimation: false,
                          effectType: "ripple", //涟漪特效
                          showEffectOn: "render", //配置何时显示特效。可选：'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
                          rippleEffect: { //涟漪特效相关配置。
                          period: 4, //动画的时间。
                          scale: 4, //动画中波纹的最大缩放比例。

                          // brushType: 'stroke', //波纹的绘制方式，可选 'stroke' 和 'fill'。
                          },
                          // data: arra1
                          data:echartsDrawA
                        //   data:[
                        //     {name: 'NodeId', datas:['4646'],value: ["104.03876", "30.59262"]},
                        //     {name: 'NodeId', datas:['4647'],value: ["104.03876", "31.59262"]}
                        // ]
                      },
                  ],

              });
            window.addEventListener("resize",function(){
                mainMap.resize();
            });
            // $('#mainMap').resize(function(){
            //     mainMap.resize();
            // });
        })
        .catch(error =>{
          console.log(error);
          // alert("服务器响应超时");
          this.$message({
            message:'服务器响应超时',
            type:'warning',
          })
          mainMap.hideLoading();
        })

      },
      aveTimeShow(){
        if($('.aveTimeHide').css("display") == 'none'){
          $('.aveTimeHide').show();
        }
        else{
          $('.aveTimeHide').hide();
        }
      },
      aveBroadbandShow(){
        if($('.aveBroadbandHide').css("display") == 'none'){
          $('.aveBroadbandHide').show();
        }
        else{
          $('.aveBroadbandHide').hide();
        }
      },


    }
};
</script>
<style lang="scss" scoped>
.ycsj_p_ul{
  width: 70%;
  float: left;
  margin-left: 20px;
  margin-top: 17px;
  li{
    text-align: center;
    float: left;
    width: 30%;
  }
  .ycsj_p_ul_span{
    font-size: 12px;
    color: #4A4A4A;
  }
  .ycsj_p_ul_span2{
    font-size: 20px;
    color: #4D74FF;
  }
}
.title-message{
  margin: 0 30px;
  font-size: 14px;
  ul{
    margin-top: 21px;
    li{
      float: left;
      width: 25%;
      img{
        vertical-align: unset;
      }
    }
  }
  p{
    display: inline-block;
  }
  img{
    width: 30px;
    margin-right: 5px;
  }
}
.contentview{
  width: 100% !important;
}
.title{
padding: 10px;
}
.chain_yx{
width: 85%;
margin: 0 auto;
margin-top: 20px;
background: #F1F4FF;
height: 80px;
font-size: 18px;
display: flex;
-webkit-display: flex;
justify-content: space-around;
align-items: center;
color: #4A4A4A;
p{
img{
  width: 26px;
  display: inline-block;
  vertical-align: top;
}
}
}
.title-content-a2{
margin-top: 10px !important;
height: 660px !important;
}
.content_slzs{
font-size: 14px;
padding-left: 30px;
padding-top: 10px;
color: #4A4A4A;
span{
display: inline-block;
height: 20px;
vertical-align: middle;
}
p{
width: 69%;
display: inline-block;
.content_heng1{
  background: #8635F0;
  width: 100%;
}
.content_heng2{
  width: 50%;
  background: #50CC50;
}
span{
  display: inline-block;
  height: 20px;
  vertical-align: middle;
}
.content_slzs_s{
  border-radius: 30px;
  display: inline-block;
  height: 20px;
}
}

}
#echartContainerCity,#mainMap{
width: 100%;
height: 100%;
min-height: 200px;
}
#mainMap{
  margin-top: -68px;
  top:-13px;
}
.ycsj_p_div{
padding-left: 12px;
font-size: 28px;
font-weight: bold;
ul{
li{
  width: 50px;
  height: 50px;
  background: #D2DCFF;
  color: #4d74ff;
  float: left;
  margin-left: 18px;
  text-align: center;
  line-height: 50px;
}
}
}
.ycsj_p{
font-size: 18px;
padding: 30px 0 30px 30px;
color: #4A4A4A;
cursor: pointer;
.rightJt{
border-radius: 50%;
-webkit-border-radius: 50%;
border: 1px solid #333;
font-size: 14px;
width: 14px;
height: 14px;
display: inline-block;
padding: 1px;
vertical-align: text-top;
margin-top: 3px;
}
}


.title-content{
display: flex;
-webkit-display: flex;
justify-content: center;
.title-content-a{
height: 200px;
box-shadow: #B7C7FF 0px 0px 20px;
margin-top: 39px;
margin-bottom: 39px;
.title-content-a-view{
  width: 39%;
  float: left;
}
.title-content-b-view{
  width: 69%;
  float: left;
}
}

div:first-child{
width: 69%;
}
.title-content-ab{
margin-left: 50px;
width: 28%;
background: #FFF;
}
}
.el-button{
  border: 0 !important;
  background: 0 !important;
}
.el-icon-question:before {
    content: "\E634";
    font-size: 22px;
    color: #456ca1;
    cursor: pointer;
}
</style>
